import { render, staticRenderFns } from "./activityEditSemesterShifts.html?vue&type=template&id=4212c9f9&scoped=true&"
import script from "./activityEditSemesterShifts.vue?vue&type=script&lang=js&"
export * from "./activityEditSemesterShifts.vue?vue&type=script&lang=js&"
import style0 from "./activityEditSemesterShifts.css?vue&type=style&index=0&id=4212c9f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212c9f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDataTable,VRow,VSelect,VTreeview})
